import {generateArea, generateIsraeliAddress, generateSmallNumber} from '../utils';

import type {AssetFieldKey} from '@sollapay/domain/asset-types';

/**
 * Exhaustive over every `AssetFieldKey` except `description` — that one needs the
 * asset type, so it's generated separately via `generateAssetDescription`.
 */
export const ASSET_FIELD_GENERATORS: Record<Exclude<AssetFieldKey, 'description'>, () => string> = {
  buildingNumber: generateSmallNumber,
  unitNumber: generateSmallNumber,
  address: generateIsraeliAddress,
  floor: generateSmallNumber,
  block: generateSmallNumber,
  parcel: generateSmallNumber,
  subParcel: generateSmallNumber,
  area: generateArea
};
